import i18nSingleton from '@/i18n';
import { isRef } from 'vue';

/**
 * Set the i18n locale based on the store's language locale code (e.g. 'nl_NL').
 * If the locale's messages have not been loaded yet, vue-i18n falls back to
 * `fallbackLocale` automatically.
 *
 * Pass an explicit `i18nInstance` in SSR contexts where each request uses its
 * own fresh i18n instance rather than the module-level singleton.
 */
export function setupStoreLocale(languageLocale: string | undefined, i18nInstance: typeof i18nSingleton = i18nSingleton): void {
    if (!languageLocale) {
        return;
    }

    if (isRef(i18nInstance.global.locale)) {
        i18nInstance.global.locale.value = languageLocale;
    }
}
